'use strict';

var themeColors = {
    white: '#ffffff',
    black: '#000000',
    blue: {
        5: '#F0F9FF',
        10: '#E4F3FE',
        20: '#C5E5FC',
        30: '#87CAFA',
        40: '#41A1ED',
        50: '#0B82E3',
        60: '#0171D3',
        70: '#015CBE',
        80: '#003EA1',
        90: '#0C227B',
        100: '#0C154B',
    },
    gray: {
        5: '#F9FBFD',
        10: '#F5F8FA',
        20: '#E7ECF1',
        30: '#CED7E0',
        40: '#A8B3BF',
        50: '#7B8694',
        60: '#596471',
        70: '#404A57',
        80: '#2E3643',
        90: '#232836',
        100: '#181D2B',
    },
    slate: {
        20: '#4E7294',
        30: '#355A7C',
        40: '#234465',
        50: '#163351',
        60: '#0D2640',
        70: '#081C34',
        80: '#040F25',
    },
    silver: {
        20: '#F4F9FF',
        30: '#EFF6FD',
        40: '#E3EEF8',
        50: '#D0E0F0',
        60: '#B5CCE4',
        70: '#96B4D3',
        80: '#7A9CBF',
    },
    red: {
        5: '#FEF4F5',
        10: '#FCE8EB',
        20: '#F8C9D1',
        30: '#F196A8',
        40: '#E65476',
        50: '#DA003E',
        60: '#C90036',
        70: '#B10038',
        80: '#900037',
        90: '#63002D',
        100: '#3E001D',
    },
    pink: {
        5: '#FFF7FB',
        10: '#FFF0F8',
        20: '#FCD9EC',
        30: '#F5A9D1',
        40: '#E673B0',
        50: '#D12687',
        60: '#C2217C',
        70: '#A90F6B',
        80: '#82095D',
        90: '#5B034F',
        100: '#420241',
    },
    green: {
        5: '#F6FCEB',
        10: '#E8FCCA',
        20: '#D6F7A3',
        30: '#C0F274',
        40: '#A7E549',
        50: '#8FD428',
        60: '#7BBA1C',
        70: '#659E10',
        80: '#4C750D',
        90: '#334F09',
        100: '#233607',
    },
    teal: {
        5: '#F0FFF9',
        10: '#E0FFF4',
        20: '#C3FAE6',
        30: '#94F7D5',
        40: '#5CE5B7',
        50: '#26D19F',
        60: '#01BB86',
        70: '#019871',
        80: '#006D58',
        90: '#004C44',
        100: '#003636',
    },
    skinYellow: {
        20: '#FFF4E8',
        30: '#FFEDD9',
        40: '#F9E0C0',
        50: '#F7D2A6',
        60: '#EEBE86',
        70: '#E9B375',
        80: '#DD9F5D',
    },
    yellow: {
        5: '#FFFBEB',
        10: '#FFF8D4',
        20: '#FFF2B5',
        30: '#FEE881',
        40: '#FDD94B',
        50: '#F9C900',
        60: '#EA9F00',
        70: '#D07800',
        80: '#A65000',
        90: '#7E3200',
        100: '#411300',
    },
    indigo: {
        5: '#F6F7FF',
        10: '#ECEFFE',
        20: '#D4D8FC',
        30: '#A5AAFA',
        40: '#676BE5',
        50: '#4749D1',
        60: '#3832C0',
        70: '#3128AA',
        80: '#2A1E95',
        90: '#1B0D69',
        100: '#11024C',
    },
    purple: {
        5: '#FBF7FF',
        10: '#F6EFFE',
        20: '#EAD9FC',
        30: '#D3AFFA',
        40: '#A46CE5',
        50: '#8440D7',
        60: '#6B28C4',
        70: '#5517AC',
        80: '#400D90',
        90: '#2E0770',
        100: '#1E044F',
    },
    orange: {
        5: '#FFF8F1',
        10: '#FEEFE5',
        20: '#FCDDC9',
        30: '#F8BD9B',
        40: '#F2925E',
        50: '#E75E1A',
        60: '#D84400',
        70: '#C23D00',
        80: '#A23100',
        90: '#762300',
        100: '#421400',
    },
    other: {
        sdk: {
            background: '#2C423F',
        },
        loader: {
            bubble: '#41A1ED',
            satellite: '#87CAFA',
        },
        trustpilotStars: {
            red: '#FF3722',
            orange: '#FF8622',
            yellow: '#FFCE00',
            green: '#73CF11',
            darkGreen: '#00B67A',
        },
        avatar: {
            0: '#704337',
            1: '#659E10',
            2: '#D07800',
            3: '#676BE5',
            4: '#C2217C',
            5: '#355A7C',
            6: '#D84400',
            7: '#019871',
            8: '#E65476',
            9: '#3832C0',
            10: '#003EA1',
            11: '#400D90',
        },
        trustpilotInactive: '#DCDCE6',
    },
};
exports.FONT_WEIGHT = void 0;
(function (FONT_WEIGHT) {
    FONT_WEIGHT[FONT_WEIGHT["REGULAR"] = 400] = "REGULAR";
    FONT_WEIGHT[FONT_WEIGHT["MEDIUM"] = 500] = "MEDIUM";
    FONT_WEIGHT[FONT_WEIGHT["BOLD"] = 700] = "BOLD";
})(exports.FONT_WEIGHT || (exports.FONT_WEIGHT = {}));
var transitionTime = 0.3;
var themeBorder = {
    radius: {
        default: 8,
    },
    default: "1px solid ".concat(themeColors.gray[100]),
    white: "1px solid ".concat(themeColors.white),
};
var themeShadows = {
    smallWhite: '0px 4px 4px 0px rgba(35, 68, 101, 0.05), 0px 4px 16px 0px rgba(35, 68, 101, 0.05);',
    mediumBlue5: '0px 4px 4px 0px rgba(0, 62, 161, 0.10), 0px 4px 16px 0px rgba(0, 62, 161, 0.10);',
};
var backgrounds = {
    transparent: 'transparent',
    white: themeColors.white,
    blue: themeColors.blue[5],
    dark: themeColors.blue[10],
    yellow: '#FFDDA2',
    outerSpace: themeColors.other.sdk.background,
};

exports.backgrounds = backgrounds;
exports.themeBorder = themeBorder;
exports.themeColors = themeColors;
exports.themeShadows = themeShadows;
exports.transitionTime = transitionTime;
//# sourceMappingURL=styles-2eec2580.js.map
